/* eslint-disable node/no-unsupported-features */
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import store from './store';
import registerServiceWorker from './registerServiceWorker';
import Themer from './components/Themer';

import './index.css';

const target = document.querySelector('#root');

render(
    <Provider store={store}>
        <Themer/>
    </Provider>,
    target
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js